import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase-config';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { motion, AnimatePresence } from "framer-motion";
import UploadModal from './uploadPopup';
import { useSnackbar } from "../context/SnackbarContext";


// img
import camera from "../../img/uploadcamera.svg"
import galleryupload from "../../img/uploadgallery.svg"
import RotatePhonePopup from '../RotatePhonePopup';
import retake from "../../img/plus.svg"
import logo from "../../img/hint-popup/lol.png"
import { useLanguage } from '../context/Languagecontext';
import { convertToNativeNumerals } from '../../utils/numberUtils';
import useBadWordDetection from '../../hooks/Usebadworddetection';
import BadWordWarning from './Badwordwarning';


const AllHintPage = ({ data, inboxDoc }) => {
    const { lanText, t } = useLanguage();
    const { showSnackbar } = useSnackbar();
    const { username, category, timestamp } = useParams();
    const [hintText, setHintText] = useState('');
    const { hasBadWord } = useBadWordDetection(hintText);
    const [selectedRelation, setSelectedRelation] = useState(null);
    const [isShaking, setIsShaking] = useState(false);
    const [currentHintIndex, setCurrentHintIndex] = useState(0);
    const [isTextareaFocused, setIsTextareaFocused] = useState(false);
    const navigate = useNavigate();
    const eventLogged = useRef(false);
    const textareaRef = useRef(null);
    const mainContainerRef = useRef(null);
    const getInitialActiveTab = () => {
        const next = sessionStorage.getItem("next");
        const validNext = (next === "0" || next === "1") ? parseInt(next) : 0;
        return validNext;
    };

    const [active, setActive] = useState(getInitialActiveTab);
    const [prevActive, setPrevActive] = useState(getInitialActiveTab);
    const [showModal, setShowModal] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [imageModal, setImageModal] = useState(false);
    const iosGalleryInputRef = useRef(null); // New ref for iOS gallery input
    const [opencvReady, setOpencvReady] = useState(false);
    const imagesToCache = [
        camera,
        galleryupload,
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorderpurple.svg",
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorder9.svg",
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorder%20(2).svg",
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/cameraIcon.svg",
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorderorange.svg",
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorderBlue.svg",
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorderWhite.svg",
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorder11.svg",
        "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieImage.svg"
    ];

    const [cachedImages, setCachedImages] = useState({
        camera: camera,
        gallery: galleryupload,
        selfieBorderPurple: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorderpurple.svg",
        selfieBorder9: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorder9.svg",
        selfieBorderBlue: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorderBlue.svg",
        selfieBorderWhite: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorderWhite.svg",
        selfieBorder11: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorder11.svg",
        selfieBorderOrange: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorderorange.svg",
        selfieBorder: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorder%20(2).svg",
        selfieImage: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieImage.svg",
        cameraIcon: "https://lol-image-bucket.s3.ap-south-1.amazonaws.com/cameraIcon.svg"
    });

    useEffect(() => {
        const loadCachedModalImages = async () => {
            const newCachedImages = { ...cachedImages };

            const cachedCameraUrl = await getCachedImage(camera);
            const cachedGalleryUrl = await getCachedImage(galleryupload);
            const cachedSelfieBorderPurple = await getCachedImage("https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorderpurple.svg");
            const cachedSelfieBorderBlue = await getCachedImage("https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorderBlue.svg");
            const cachedSelfieBorder9 = await getCachedImage("https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorder9.svg");
            const cachedSelfieBorderOrange = await getCachedImage("https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorderorange.svg");
            const cachedSelfieBorder11 = await getCachedImage("https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorder11.svg");
            const cachedSelfieBorderWhite = await getCachedImage("https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorderWhite.svg");
            const cachedSelfieBorder = await getCachedImage("https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieBorder%20(2).svg");
            const cachedSelfieImage = await getCachedImage("https://lol-image-bucket.s3.ap-south-1.amazonaws.com/selfieImage.svg");
            const cachedCameraIcon = await getCachedImage("https://lol-image-bucket.s3.ap-south-1.amazonaws.com/cameraIcon.svg");

            if (cachedCameraUrl) newCachedImages.camera = cachedCameraUrl;
            if (cachedGalleryUrl) newCachedImages.gallery = cachedGalleryUrl;
            if (cachedSelfieBorderPurple) newCachedImages.selfieBorderPurple = cachedSelfieBorderPurple;
            if (cachedSelfieBorderBlue) newCachedImages.selfieBorderBlue = cachedSelfieBorderBlue;
            if (cachedSelfieBorder9) newCachedImages.selfieBorder9 = cachedSelfieBorder9;
            if (cachedSelfieBorderOrange) newCachedImages.selfieBorderOrange = cachedSelfieBorderOrange;
            if (cachedSelfieBorder11) newCachedImages.selfieBorder11 = cachedSelfieBorder11;
            if (cachedSelfieBorderWhite) newCachedImages.selfieBorderWhite = cachedSelfieBorderWhite;
            if (cachedSelfieBorder) newCachedImages.selfieBorder = cachedSelfieBorder;
            if (cachedSelfieImage) newCachedImages.selfieImage = cachedSelfieImage;
            if (cachedCameraIcon) newCachedImages.cameraIcon = cachedCameraIcon;

            setCachedImages(newCachedImages);
        };

        loadCachedModalImages();
    }, []);

    const [isCheckingConnection, setIsCheckingConnection] = useState(false);
    const [isCheckingConnection2, setIsCheckingConnection2] = useState(false);
    const [isCheckingConnection3, setIsCheckingConnection3] = useState(false);


    const isInAppBrowser = () => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        return /Instagram|FBAN|FBAV|Messenger|Telegram|Snapchat|Snap/i.test(ua);
    };

    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isSmallScreen = window.innerWidth < 376 && window.innerWidth !== 360;

    const data2 = data.question

    const subCat = useMemo(() => {
        return Array.isArray(data2)
            ? data2.find(item => item.category === category)?.answer.subCategory
            : undefined;
    }, [data, category]);

    const subCatReady = category !== "RnJpZW5k" || subCat !== undefined;

    const handleBoxClick = async () => {
        if (isIOS) {
            setIsCheckingConnection(true);

            // Check internet connection (includes 2 sec delay inside)
            const isOnline = await checkInternetConnection();

            setIsCheckingConnection(false);

            if (!isOnline) {
                showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
                return;
            }

            if (iosGalleryInputRef.current) {
                iosGalleryInputRef.current.click();
            }
            return;
        }

        setIsCheckingConnection(true);

        // Check internet connection (includes 2 sec delay inside)
        const isOnline = await checkInternetConnection();

        setIsCheckingConnection(false);

        if (!isOnline) {
            showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
            return;
        }

        setShowModal(true);
    };

    const handleBoxClick2 = async () => {
        if (isIOS) {

            setIsCheckingConnection3(true);

            // Check internet connection (includes 2 sec delay inside)
            const isOnline = await checkInternetConnection();

            setIsCheckingConnection3(false);

            if (!isOnline) {
                showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");

                return;
            }
            // On iOS, directly trigger file input instead of modal
            if (iosGalleryInputRef.current) {
                iosGalleryInputRef.current.click();
            }
            return;
        }

        setIsCheckingConnection3(true);

        // Check internet connection (includes 2 sec delay inside)
        const isOnline = await checkInternetConnection();

        setIsCheckingConnection3(false);

        if (!isOnline) {
            showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
            return;
        }

        setShowModal(true);
    };

    const handleBoxClick3 = async () => {
        if (isIOS) {

            setIsCheckingConnection2(true);

            // Check internet connection (includes 2 sec delay inside)
            const isOnline = await checkInternetConnection();

            setIsCheckingConnection2(false);

            if (!isOnline) {
                showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
                return;
            }
            // On iOS, directly trigger file input instead of modal
            if (iosGalleryInputRef.current) {
                iosGalleryInputRef.current.click();
            }
            return;
        }

        setIsCheckingConnection2(true);

        // Check internet connection (includes 2 sec delay inside)
        const isOnline = await checkInternetConnection();

        setIsCheckingConnection2(false);

        if (!isOnline) {
            showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
            return;
        }

        setShowModal(true);
    };

    const handleImageSelect = (imageData) => {
        setSelectedImage(imageData);
    };

    const items = [
        { default: t.hinttext },
        { default: t.hintimage }
    ];

    const relationKeys = t?.relations ? Object.keys(t.relations) : [];
    const maxLength = 50;
    const typedChars = [...hintText].length;
    const remainingChars = maxLength - [...hintText].length;

    // Animation variants for slide transitions
    const slideVariants = {
        enter: (direction) => ({
            x: direction > 0 ? '100%' : '-100%',
            opacity: 0
        }),
        center: {
            x: 0,
            opacity: 1
        },
        exit: (direction) => ({
            x: direction > 0 ? '-100%' : '100%',
            opacity: 0
        })
    };

    // Load OpenCV
    useEffect(() => {
        loadOpenCV();
    }, []);

    // Cache Management Functions
    const CACHE_NAME = 'lol-image-cache-v1';
    const CACHE_EXPIRY_KEY = 'image-cache-expiry';
    const CACHE_DURATION = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds

    const cacheImage = async (url, blob) => {
        try {
            const cache = await caches.open(CACHE_NAME);
            const response = new Response(blob);
            await cache.put(url, response);

            // Store expiry timestamp
            const expiry = Date.now() + CACHE_DURATION;
            localStorage.setItem(`${CACHE_EXPIRY_KEY}-${url}`, expiry.toString());

            // console.log('Image cached successfully:', url);
        } catch (error) {
            // console.error('Error caching image:', error);
        }
    };

    const getCachedImage = async (url) => {
        try {
            // Check if cache has expired
            const expiryTime = localStorage.getItem(`${CACHE_EXPIRY_KEY}-${url}`);
            if (expiryTime && Date.now() > parseInt(expiryTime)) {
                // console.log('Cache expired for:', url);
                return null;
            }

            const cache = await caches.open(CACHE_NAME);
            const response = await cache.match(url);

            if (response) {
                const blob = await response.blob();
                return URL.createObjectURL(blob);
            }
            return null;
        } catch (error) {
            // console.error('Error retrieving cached image:', error);
            return null;
        }
    };

    const loadOpenCV = () => {
        // Check if OpenCV is already loaded
        if (window.cv && window.cv.CascadeClassifier) {
            setOpencvReady(true);
            // console.log('OpenCV already loaded');
            return;
        }

        // Check if script is already being loaded
        const existingScript = document.querySelector('script[src*="opencv.js"]');
        if (existingScript) {
            // console.log('OpenCV script already exists, waiting for it to load...');
            const checkOpenCV = setInterval(() => {
                if (window.cv && window.cv.CascadeClassifier) {
                    clearInterval(checkOpenCV);
                    setOpencvReady(true);
                    // console.log('OpenCV loaded successfully (existing script)');
                }
            }, 100);

            setTimeout(() => {
                clearInterval(checkOpenCV);
                if (!window.cv || !window.cv.CascadeClassifier) {
                    // console.error('OpenCV failed to load after timeout');
                }
            }, 30000);
            return;
        }

        // Load OpenCV.js
        const script = document.createElement('script');
        script.src = 'https://docs.opencv.org/4.5.2/opencv.js';
        script.async = true;
        script.id = 'opencv-script';

        script.onload = () => {
            // console.log('OpenCV script loaded, waiting for initialization...');
            const checkOpenCV = setInterval(() => {
                if (window.cv && window.cv.CascadeClassifier) {
                    clearInterval(checkOpenCV);
                    setOpencvReady(true);
                    // console.log('OpenCV initialized successfully');
                }
            }, 100);

            setTimeout(() => {
                clearInterval(checkOpenCV);
                if (!window.cv || !window.cv.CascadeClassifier) {
                    // console.error('OpenCV failed to initialize after timeout');
                }
            }, 30000);
        };

        script.onerror = () => {
            // console.error('Failed to load OpenCV script');
        };

        document.body.appendChild(script);
    };

    // Compress image function (same as UploadModal)
    const compressImage = (file) => {
        return new Promise((resolve, reject) => {
            if (file.type === 'image/gif') {
                resolve(file);
                return;
            }

            const reader = new FileReader();
            reader.onload = (event) => {
                const img = document.createElement('img');
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    let width = img.width;
                    let height = img.height;
                    const MAX_WIDTH = 1200;
                    const MAX_HEIGHT = 1200;

                    if (width > height) {
                        if (width > MAX_WIDTH) {
                            height = Math.round((height * MAX_WIDTH) / width);
                            width = MAX_WIDTH;
                        }
                    } else {
                        if (height > MAX_HEIGHT) {
                            width = Math.round((width * MAX_HEIGHT) / height);
                            height = MAX_HEIGHT;
                        }
                    }

                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);
                    const quality = 0.7;

                    canvas.toBlob(
                        (blob) => {
                            if (!blob) {
                                reject(new Error('Canvas to Blob conversion failed'));
                                return;
                            }
                            const compressedFile = new File([blob], file.name, {
                                type: file.type,
                                lastModified: Date.now(),
                            });
                            resolve(compressedFile);
                        },
                        file.type,
                        quality
                    );
                };
                img.onerror = () => reject(new Error('Failed to load image'));
                img.src = event.target.result;
            };
            reader.onerror = () => reject(new Error('Failed to read file'));
            reader.readAsDataURL(file);
        });
    };

    // Load cascade classifier with retry (same as UploadModal)
    const loadCascade = async (cascadeUrl, filename) => {
        try {
            const response = await fetch(cascadeUrl);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const xmlData = await response.text();

            // Create the cascade file in OpenCV's virtual file system
            window.cv.FS_createDataFile('/', filename, xmlData, true, false, false);

            return true;
        } catch (error) {
            // console.error(`Error loading cascade ${filename}:`, error);
            return false;
        }
    };

    // Enhanced face detection (same as UploadModal)
    const detectFaceWithOpenCV = async (imageDataUrl) => {
        return new Promise((resolve, reject) => {
            const img = document.createElement('img');
            img.onload = async () => {
                let src, gray, faceCascade;

                try {
                    const cv = window.cv;

                    // Create canvas and draw image
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);

                    // Read image into OpenCV Mat
                    src = cv.imread(canvas);
                    gray = new cv.Mat();

                    // Convert to grayscale
                    cv.cvtColor(src, gray, cv.COLOR_RGBA2GRAY);

                    // Apply histogram equalization for better detection
                    cv.equalizeHist(gray, gray);

                    // Use single optimized cascade for speed
                    const cascadeConfig = {
                        url: 'https://raw.githubusercontent.com/opencv/opencv/master/data/haarcascades/haarcascade_frontalface_default.xml',
                        filename: 'haarcascade_frontalface_default.xml'
                    };

                    // Load cascade
                    faceCascade = new cv.CascadeClassifier();

                    let loaded = false;
                    try {
                        loaded = faceCascade.load(cascadeConfig.filename);
                    } catch (e) {
                        // console.log('Cascade not in filesystem, loading...');
                    }

                    if (!loaded) {
                        const success = await loadCascade(cascadeConfig.url, cascadeConfig.filename);
                        if (success) {
                            loaded = faceCascade.load(cascadeConfig.filename);
                        }
                    }

                    if (!loaded) {
                        throw new Error('Failed to load face detection model');
                    }

                    // Fast detection with optimized parameters
                    const faces = new cv.RectVector();
                    const minSize = new cv.Size(30, 30);

                    faceCascade.detectMultiScale(
                        gray,
                        faces,
                        1.1,
                        3,
                        0,
                        minSize
                    );

                    const numFaces = faces.size();
                    // console.log(`Detected ${numFaces} face(s)`);

                    // Cleanup
                    faces.delete();
                    faceCascade.delete();
                    src.delete();
                    gray.delete();

                    // Simple check - face detected or not
                    if (numFaces > 0) {
                        resolve({
                            success: true,
                            count: numFaces
                        });
                    } else {
                        resolve({
                            success: false,
                            count: 0,
                            error: 'no_face'
                        });
                    }

                } catch (error) {
                    // console.error('OpenCV detection error:', error);
                    // Cleanup any remaining objects
                    if (src) src.delete();
                    if (gray) gray.delete();
                    if (faceCascade) faceCascade.delete();
                    reject(error);
                }
            };
            img.onerror = () => reject(new Error('Failed to load image for face detection'));
            img.src = imageDataUrl;
        });
    };

    // Handle iOS file selection with face detection
    const handleIOSFileChange = async (e) => {
        const isOnline = await checkInternetConnection();
        if (!isOnline) {
            showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
            return;
        }

        const selectedFile = e.target.files[0];

        // Reset input value to allow selecting the same file again
        e.target.value = '';

        if (!selectedFile) {
            setIsProcessing(false);
            return;
        }

        // if (!opencvReady) {
        //     setIsProcessing(false);
        //     setSnackbar({
        //         show: true,
        //         message: t.galleryMSG || 'Please add your face',
        //         type: 'error'
        //     });
        //     setTimeout(() => {
        //         setSnackbar({ show: false, message: '', type: 'error' });
        //     }, 3000);
        //     return;
        // }

        try {
            // Start processing
            setIsProcessing(true);

            // Compress image
            const compressed = await compressImage(selectedFile);

            // Check size
            if (compressed.size > 5 * 1024 * 1024) {
                setIsProcessing(false);
                showSnackbar(t?.sizeError || 'Image size exceeds 5MB limit', "error");
                return;
            }

            // Convert to base64
            const reader = new FileReader();
            reader.onloadend = async () => {
                const imageDataUrl = reader.result;
                setIsProcessing(false);
                setSelectedImage(imageDataUrl);
            };
            reader.onerror = () => {
                setIsProcessing(false);
            };
            reader.readAsDataURL(compressed);
        } catch (error) {
            setIsProcessing(false);
        }
    };

    useEffect(() => {
        const preloadAndCacheImages = async () => {
            for (const src of imagesToCache) {
                try {
                    // Check if already cached
                    const cachedUrl = await getCachedImage(src);
                    if (cachedUrl) {
                        // console.log('Image already cached:', src);
                        continue;
                    }

                    // Fetch and cache the image
                    const response = await fetch(src);
                    const blob = await response.blob();
                    await cacheImage(src, blob);

                    // Preload for immediate use
                    const img = new Image();
                    img.src = src;
                } catch (error) {
                    // console.error('Error preloading/caching image:', src, error);
                }
            }
        };

        preloadAndCacheImages();
    }, []);

    useEffect(() => {
        const loadCachedImages = async () => {
            const images = [camera, galleryupload];

            for (const src of images) {
                const cachedUrl = await getCachedImage(src);
                if (cachedUrl) {
                    // Use cached image
                    // console.log('Using cached image:', src);
                }
            }
        };

        loadCachedImages();
    }, []);

    useEffect(() => {
        // Get from sessionStorage
        const storedHint = sessionStorage.getItem("sessionHint");
        const storedImage = sessionStorage.getItem("sessionImage");
        sessionStorage.setItem("timer", "false");


        // If sessionStorage has values → use them
        if (storedHint) {
            setHintText(storedHint);
        }

        if (storedImage) {
            setSelectedImage(storedImage);
        }

        // Remove the setActive call from here since we handle it in useState initialization
    }, [inboxDoc]);


    useEffect(() => {
        if (textareaRef.current && hintText !== textareaRef.current.innerText) {
            textareaRef.current.innerHTML = hintText || '';

            // Show tooltip if bad words exist
            requestAnimationFrame(() => {
                if (textareaRef.current) {
                    // Move cursor to end only if element is focused
                    if (document.activeElement === textareaRef.current) {
                        const range = document.createRange();
                        const selection = window.getSelection();
                        range.selectNodeContents(textareaRef.current);
                        range.collapse(false);
                        selection.removeAllRanges();
                        selection.addRange(range);
                    }
                }
            });
        }
    }, [hintText]);

    // Update textarea when switching back to text hint tab (after animation completes)
    useEffect(() => {
        if (active === 0) {
            // Wait for animation to complete and DOM to be ready
            const timeoutId = setTimeout(() => {
                if (textareaRef.current) {
                    const currentText = textareaRef.current.innerText || '';
                    // Update if hintText exists and is different from current content
                    if (hintText && hintText.trim() !== currentText.trim()) {
                        textareaRef.current.innerHTML = hintText || '';
                    } else if (hintText && !currentText) {
                        // If textarea is empty but hintText exists, set it
                        textareaRef.current.innerHTML = hintText || '';
                    }
                }
            }, 250); // Wait for slide animation (200ms) + buffer

            return () => clearTimeout(timeoutId);
        }
    }, [active, hintText]);


    useEffect(() => {
        if (!t?.hintExamples || t.hintExamples.length === 0) return; // ✅ ADD THIS

        if (!isTextareaFocused && !hintText) {
            const interval = setInterval(() => {
                setCurrentHintIndex((prevIndex) =>
                    (prevIndex + 1) % t.hintExamples.length
                );
            }, 2500);

            return () => clearInterval(interval);
        }
    }, [isTextareaFocused, hintText, t?.hintExamples?.length]);

    useEffect(() => {
        const isDisabled = isCheckingConnection || isCheckingConnection2 || isCheckingConnection3 || isProcessing;
        window.dispatchEvent(new CustomEvent('dropdownDisabledState', {
            detail: { disabled: isDisabled }
        }));
    }, [isCheckingConnection, isCheckingConnection2, isCheckingConnection3, isProcessing]);

    const triggerShake = () => {
        setIsShaking(true);
        setTimeout(() => setIsShaking(false), 600);
    };

    const handleBlur = () => {
        setIsTextareaFocused(false);
        requestAnimationFrame(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            if (mainContainerRef.current) {
                mainContainerRef.current.scrollTop = 0;
            }
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        });
    };

    const handleFocus = () => {
        setIsTextareaFocused(true);
    };

    const handleChipSelect = (relationKey) => {
        const relationValue = t.relations[relationKey];

        let isSelected;
        if (['hi', 'mr', 'ta'].includes(lanText)) {
            isSelected = hintText.includes(relationValue);
        } else {
            const escapedChipText = relationValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regex = new RegExp(`\\b${escapedChipText}\\b`, 'i');
            isSelected = regex.test(hintText);
        }

        if (isSelected) {
            let newText;
            if (['hi', 'mr', 'ta'].includes(lanText)) {
                newText = hintText.replace(relationValue, '').trim();
            } else {
                const escapedChipText = relationValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const regex = new RegExp(`\\b${escapedChipText}\\b`, 'i');
                newText = hintText.replace(regex, '').trim();
            }

            newText = newText.replace(/\s+/g, ' ');
            setHintText(newText);

            if (textareaRef.current) {
                textareaRef.current.innerHTML = newText;

                // ✅ Move cursor to end after updating content
                requestAnimationFrame(() => {
                    if (textareaRef.current) {
                        const range = document.createRange();
                        const selection = window.getSelection();
                        range.selectNodeContents(textareaRef.current);
                        range.collapse(false); // false = collapse to end
                        selection.removeAllRanges();
                        selection.addRange(range);
                    }
                });
            }

            setSelectedRelation(null);

        } else {
            const currentText = hintText.trim();
            const separator = currentText ? ' ' : '';
            const newText = currentText + separator + relationValue;

            if ([...newText].length > maxLength) {  // Fix: count Unicode code points
                triggerShake();
                return;
            }

            setHintText(newText);

            if (textareaRef.current) {
                textareaRef.current.innerHTML = newText;

                // ✅ Move cursor to end after adding chip text
                requestAnimationFrame(() => {
                    if (textareaRef.current) {
                        const range = document.createRange();
                        const selection = window.getSelection();
                        range.selectNodeContents(textareaRef.current);
                        range.collapse(false); // false = collapse to end
                        selection.removeAllRanges();
                        selection.addRange(range);
                    }
                });
            }

            setSelectedRelation({ key: relationKey, value: relationValue });
        }
    };



    // Handle tab change with animation direction
    const handleTabChange = async (index) => {
        // Check internet connection
        // const isOnline = await checkInternetConnection();
        // if (!isOnline) {
        //     setSnackbar({
        //         show: true,
        //         message: t.whoTalkin.nointertoast,
        //         type: 'error'
        //     });
        //     setTimeout(() => {
        //         setSnackbar({ show: false, message: '', type: 'error' });
        //     }, 3000);
        //     return;
        // }

        setPrevActive(active);
        setActive(index);
    };

    //  useEffect(() => {
    //     if (active === 0) {
    //         // Restore hint text from sessionStorage when switching back to text hint tab
    //         const storedHint = sessionStorage.getItem("sessionHint");
    //         if (storedHint) {
    //             setHintText(storedHint);
    //         } //else if (inboxDoc?.hintText) {
    //         // setHintText(inboxDoc.hintText);
    //         // sessionStorage.setItem("sessionHint", inboxDoc.hintText);
    //         //}
    //         // setSelectedImage(null);
    //     } else if (active === 1) {
    //         // Save hint text to sessionStorage before clearing (if it exists)
    //         if (hintText.trim()) {
    //             sessionStorage.setItem("sessionHint", hintText.trim());
    //         }
    //         setHintText('');
    //         // setSelectedRelation(null);
    //     }
    // }, [active]);

    // Check internet connectivity function
    const checkInternetConnection = async () => {
        // Add 2 second delay
        await new Promise(resolve => setTimeout(resolve, 700));

        // First check navigator.onLine
        if (!navigator.onLine) {
            return false;
        }

        // Double-check with a real network request
        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

            clearTimeout(timeoutId);
            return true;
        } catch (error) {
            // console.log('Network check failed:', error);
            return false;
        }
    };

    const handleSendClick = async () => {
        // Set checking state to show loader
        setIsCheckingConnection(true);

        // Check internet connection first (includes 2 second delay)
        const isOnline = await checkInternetConnection();

        setIsCheckingConnection(false);

        if (!isOnline) {
            showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
            return;
        }

        const formData = {
            originalData: data,
            timestamp: timestamp,
        };

        // ✅ Always save hint if it exists
        formData.hint = hintText.trim();
        sessionStorage.setItem("sessionHint", hintText.trim());

        // ✅ Always save image if it exists
        if (selectedImage) {
            formData.uploadedImage = selectedImage;
            sessionStorage.setItem("sessionImage", selectedImage);
        }

        // ✅ Always save the active tab
        sessionStorage.setItem("next", active.toString());

        const path =
            category === "UGljIFJvYXN0"
                ? `/${username || ''}/${category || ''}/${timestamp || ''}/next`
                : `/${username || ''}/${category || ''}/next`;

        navigate(path, { state: formData });

        window.scrollTo(0, 0);
    };


    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.target.blur();
        }
    };

    const chipBgColor = useMemo(() => {
        if (category === "RnJpZW5k") {
            return subCat !== "RnJpZW5k" ? "#FFD1D4" : "#DEDBFF";
        }

        switch (category) {
            case "V2hvVGFsa2lu": return "#D5C8F8";
            case "UGljIFJvYXN0": return "#DCE6F8";
            case "QW5ub3kgZnVuIENhcmQ=": return "#FFF4F2";
            case "RW1vdGlvbg==": return "#FFEECF";
            case "Q29uZmVzc2lvbg==": return "#DB9EFF";
            case "SG90bmVzcw==": return "#FFF4F2";
            case "Um9hc3Q=": return "#FECCA2";
            case "UnVtb3Vy": return "#FFFFFF";
            case "Q2hhbGxlbmdl": return "#FFFFFF";
            case "SGVhdmVuSGVsbA==": return "#FFFFFF";
            case "UmVwdXRhdGlvbg==": return "#FFFFFF";
            case "SW1wcmVzc2lvbg==": return "#FFFFFF";
            default: return "rgba(255, 255, 255, 0.8)";
        }
    }, [category, subCat]);

    const buttonBg = useMemo(() => {
        if (category === "RnJpZW5k") {
            return subCat !== "RnJpZW5k" ? "#FFD2D5" : "#DEDBFF";
        }

        switch (category) {
            case "V2hvVGFsa2lu": return "#D5C8F8";
            case "UGljIFJvYXN0": return "#DCE6F8";
            case "QW5ub3kgZnVuIENhcmQ=": return "#FE8EB4";
            case "RW1vdGlvbg==": return "#EFCC8D";
            case "Q29uZmVzc2lvbg==": return "#DB9EFF";
            case "SG90bmVzcw==": return "#FFB296";
            case "Um9hc3Q=": return "#FCD4B8";
            case "UnVtb3Vy": return "#ffffff";
            case "Q2hhbGxlbmdl": return "#FFFFFF";
            case "SGVhdmVuSGVsbA==": return "#FFFFFF";
            case "UmVwdXRhdGlvbg==": return "#FFFFFF";
            case "SW1wcmVzc2lvbg==": return "#FFFFFF";
            default: return "rgba(255, 255, 255, 0.8)";
        }
    }, [category, subCat]);

    const bgClass = useMemo(() => {
        // console.log(subCat);

        if (category === "RnJpZW5k") {
            return subCat !== "RnJpZW5k" ? "linear-gradient(to bottom, #FF617A, #FF617A)" : "linear-gradient(to bottom, #B3ADFD, #B3ADFD)";
        }

        switch (category) {
            case "V2hvVGFsa2lu": return "linear-gradient(to bottom, #684BB9, #684BB9)";
            case "UGljIFJvYXN0": return "linear-gradient(to bottom, #2F80ED, #2F80ED)";
            case "QW5ub3kgZnVuIENhcmQ=": return "linear-gradient(to bottom, #FDA881, #FF207B)";
            case "RW1vdGlvbg==": return "linear-gradient(to bottom, #FFA400, #FFA400)";
            case "Q29uZmVzc2lvbg==": return "#8001CE";  //5
            case "SG90bmVzcw==": return "linear-gradient(to bottom, #FB2A1B, #FC8B5C)";
            case "Um9hc3Q=": return "#F98423"; //8
            case "UnVtb3Vy": return "linear-gradient(0deg, #03C2FE 0%, #DE67FD 100%)";
            case "Q2hhbGxlbmdl": return "#7D5EEE";
            case "SGVhdmVuSGVsbA==": return "#00C9EB";
            case "UmVwdXRhdGlvbg==": return "linear-gradient(145deg, #703AFC, #EB7C69)";
            case "SW1wcmVzc2lvbg==": return "linear-gradient(145deg, #FFB244, #FF408B)";
            default: return "linear-gradient(to bottom, #FDA881, #FF207B)";
        }
    }, [category, subCat]);

    const hintClass = useMemo(() => {
        switch (category) {
            case "V2hvVGFsa2lu": return "hint-bg";
            case "UGljIFJvYXN0": return "hint-bg2";
            case "QW5ub3kgZnVuIENhcmQ=": return "hint-bg3";
            case "UnVtb3Vy": return "hint-bg9";
            default: return "";
        }
    }, [category, subCat]);

    const cardBg = useMemo(() => {
        if (category === "RnJpZW5k") {
            return subCat !== "RnJpZW5k" ? "#FFE2E4" : "#DEDBFF";
        }
        switch (category) {
            case "V2hvVGFsa2lu": return "#8A64F0";
            case "UGljIFJvYXN0": return "#DCE6F8";
            case "QW5ub3kgZnVuIENhcmQ=": return "#F8DFDC";
            case "RW1vdGlvbg==": return "#FFDD9F";
            case "Q29uZmVzc2lvbg==": return "#D08CFA";
            case "SG90bmVzcw==": return "#FFACA2";
            case "Um9hc3Q=": return "#FECCA2";
            case "UnVtb3Vy": return "linear-gradient(0deg, #B4E8FA 0%, #F3C4FF 70%)";
            case "Q2hhbGxlbmdl": return "#B6A5F5";
            case "SGVhdmVuSGVsbA==": return "#CEF8FF";
            case "UmVwdXRhdGlvbg==": return "#DCBBE2";
            case "SW1wcmVzc2lvbg==": return "#FFC5BA";
            default: return "#F8DFDC";
        }
    }, [category, subCat]);


    const color = useMemo(() => {
        if (category === "RnJpZW5k") {
            return subCat !== "RnJpZW5k" ? "#FF617A" : "#B3ADFD";
        }
        switch (category) {
            case "V2hvVGFsa2lu": return "#684BB9";
            case "UGljIFJvYXN0": return "#2F80ED";
            case "QW5ub3kgZnVuIENhcmQ=": return "#FF207B";
            case "RW1vdGlvbg==": return "#FFA400";
            case "Q29uZmVzc2lvbg==": return "#8001CE";
            case "SG90bmVzcw==": return "#FB2A1B";
            case "Um9hc3Q=": return "#F98423";
            case "UnVtb3Vy": return "#DE67FD";
            case "Q2hhbGxlbmdl": return "#fff";
            case "SGVhdmVuSGVsbA==": return "#00C9EB";
            case "UmVwdXRhdGlvbg==": return "#703AFC";
            case "SW1wcmVzc2lvbg==": return "#FF408B";
            default: return "#FA5E4D";
        }
    }, [category, subCat]);

    const cardBg2 = useMemo(() => {
        if (category === "RnJpZW5k") {
            return subCat !== "RnJpZW5k" ? "#FFCECE" : "#C1BCFF";
        }
        switch (category) {
            case "V2hvVGFsa2lu": return "#D5C8F8";
            case "Q29uZmVzc2lvbg==": return "#E9CAFB";
            case "Um9hc3Q=": return "#FFEBDA";
            case "UnVtb3Vy": return "#FEF6F6";
            case "Q2hhbGxlbmdl": return "#E1D9FF";
            case "SGVhdmVuSGVsbA==": return "#66E8FF";
            case "UmVwdXRhdGlvbg==": return "#fff";
            case "SW1wcmVzc2lvbg==": return "#FFEEEC";
            default: return "#FFF9F9";
        }
    }, [category, subCat]);

    const getBorderImage = (category) => {
        switch (category) {
            case "V2hvVGFsa2lu": // Voice Guessing
                return cachedImages.selfieBorderBlue;

            case "Q29uZmVzc2lvbg==": // Confession
                return cachedImages.selfieBorderPurple;

            case "Um9hc3Q=": // Roast
                return cachedImages.selfieBorderOrange;

            case "UnVtb3Vy": // Bluff
                return cachedImages.selfieBorder9;

            case "Q2hhbGxlbmdl": // Challenge
                return cachedImages.selfieBorderBlue;

            case "SGVhdmVuSGVsbA==": // HellHeaven
                return cachedImages.selfieBorder11;

            case "UmVwdXRhdGlvbg==": // Reputation
            case "SW1wcmVzc2lvbg==": // Impression
                return cachedImages.selfieBorderWhite;

            default:
                return cachedImages.selfieBorder;
        }
    };

    const isBlackText =
        category === "QW5ub3kgZnVuIENhcmQ=" ||
        category === "RW1vdGlvbg==";


    useEffect(() => {
        if (!eventLogged.current) {
            logEvent(analytics, "link_view", {
                page_location: `${window.location.origin}/${username}/${category}`,
                page_path: `/${username}/${category}`,
                debug: 'true'
            });
            eventLogged.current = true;
        }
    }, []);

    const isNextButtonEnabled = () => {
        if (active === 0) {
            return hintText.trim().length > 0;
        } else if (active === 1) {
            return !!selectedImage;
        }
        return false;
    };

    const direction = active - prevActive;


    if (!t || !t.relations || !t.hintExamples || !subCatReady) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="spinner-border" style={{ color: "#F55252" }} role="status"></div>
            </div>
        );
    }

    return (
        <>
            {/* Hidden input for iOS gallery */}
            {isIOS && (
                <input
                    ref={iosGalleryInputRef}
                    type="file"
                    accept="image/*"
                    onChange={handleIOSFileChange}
                    style={{ display: 'none' }}
                />
            )}

            {/* hint-page1-bg mathi page1-bg */}
            <div className={` GTRegular border`} ref={mainContainerRef} style={{ background: bgClass, height: "100dvh" }}>
                <div className={`h-100 pt-42 ${hintClass}`}>
                    <div className={isInAppBrowser() ? 'text-center mx-auto h-100' : 'text-center mx-auto h-100'} style={{ width: "550px", maxWidth: "90vw" }}>

                        <div className="chip-container text-center d-flex align-items-center"
                            style={{ height: '15%' }}>
                            <div className="chip" style={{ background: chipBgColor }} >
                                <div
                                    className="slider-bg"
                                    style={{ transform: `translateX(${active * 110}px)` }}
                                ></div>

                                {items.map((icon, index) => (
                                    <div
                                        key={index}
                                        className={`chip-item w-100 GTMedium`}
                                        onClick={() => {
                                            if (!isCheckingConnection && !isCheckingConnection2 && !isCheckingConnection3 && !isProcessing) {
                                                handleTabChange(index);
                                            }
                                        }}
                                        style={{
                                            pointerEvents: (isCheckingConnection || isProcessing || isCheckingConnection2 || isCheckingConnection3) ? "none" : "auto",
                                            cursor: (isCheckingConnection || isProcessing || isCheckingConnection2 || isCheckingConnection3) ? "not-allowed" : "pointer"
                                        }}
                                    >
                                        <p className={`m-0 ${active === index ? "text-white" : ""}`}>
                                            {icon.default}
                                        </p>
                                    </div>
                                ))}

                            </div>
                        </div>

                        {/* Content area with slide animation  */}
                        {/* overflowhidden remove */}
                        <div style={{ position: 'relative', height: "82%" }}>
                            <AnimatePresence initial={false} custom={direction} mode="wait">
                                {active === 0 && (
                                    <motion.div
                                        key="text"
                                        custom={direction}
                                        variants={slideVariants}
                                        initial="enter"
                                        animate="center"
                                        exit="exit"
                                        transition={{ duration: 0.2, ease: "easeInOut" }}
                                        className="text-center h-100 position-relative"
                                    >
                                        <div
                                            className={`rounded-19 mx-2 position-relative overflow-hidden ${isShaking ? 'shake-animation' : ''}`}
                                            style={{
                                                background: cardBg,
                                                height: isSmallScreen ? "220px" : "250px",
                                                boxShadow: '0px 2px 3.1px rgba(0,0,0,0.1)'
                                            }}
                                        >
                                            <div className='GTMedium d-flex align-items-center justify-content-center px-3' style={{ letterSpacing: "-0.1px", background: cardBg2, height: "28%", fontWeight: "500", fontSize: "clamp(17px , 100% , 30px)" }}>
                                                {t.enterHints}
                                            </div>
                                            <div className='h-75 p-1 text-start d-flex flex-column position-relative'>
                                                {!hintText && !isTextareaFocused && (
                                                    <div className="placeholder-container">
                                                        <div
                                                            className="animated-placeholder"
                                                            key={currentHintIndex}
                                                        >
                                                            {t.hintExamples[currentHintIndex]}
                                                        </div>
                                                    </div>
                                                )}
                                                <div
                                                    ref={textareaRef}
                                                    value={hintText}
                                                    contentEditable={!isCheckingConnection && !isProcessing}
                                                    suppressContentEditableWarning={true}
                                                    onInput={(e) => {
                                                        if (isCheckingConnection || isProcessing) return;
                                                        const inputText = e.currentTarget.innerText;

                                                        // 🔹 Prevent exceeding maxLength
                                                        if ([...inputText].length > maxLength) {
                                                            e.preventDefault();
                                                            // Restore previous valid text
                                                            const highlightedHTML = hintText || '';
                                                            e.currentTarget.innerHTML = highlightedHTML;

                                                            // Restore cursor to end
                                                            const selection = window.getSelection();
                                                            const range = document.createRange();
                                                            range.selectNodeContents(e.currentTarget);
                                                            range.collapse(false);
                                                            selection.removeAllRanges();
                                                            selection.addRange(range);

                                                            triggerShake();
                                                            return;
                                                        }

                                                        // 🔹 Save caret position BEFORE any DOM manipulation
                                                        const selection = window.getSelection();
                                                        if (!selection.rangeCount) return;

                                                        const range = selection.getRangeAt(0);
                                                        const preCaretRange = range.cloneRange();
                                                        preCaretRange.selectNodeContents(e.currentTarget);
                                                        preCaretRange.setEnd(range.endContainer, range.endOffset);
                                                        const caretOffset = preCaretRange.toString().length;

                                                        // 🔹 Update state
                                                        setHintText(inputText);

                                                        // 🔹 Update DOM with highlighted content
                                                        e.currentTarget.innerHTML = inputText;
                                                        // 🔹 Restore caret position
                                                        const restoreSelection = () => {
                                                            const newSelection = window.getSelection();
                                                            const newRange = document.createRange();
                                                            const walker = document.createTreeWalker(
                                                                e.currentTarget,
                                                                NodeFilter.SHOW_TEXT,
                                                                null
                                                            );

                                                            let currentNode = walker.nextNode();
                                                            let charsLeft = caretOffset;

                                                            while (currentNode) {
                                                                if (charsLeft <= currentNode.length) {
                                                                    try {
                                                                        newRange.setStart(currentNode, Math.min(charsLeft, currentNode.length));
                                                                        newRange.collapse(true);
                                                                        newSelection.removeAllRanges();
                                                                        newSelection.addRange(newRange);
                                                                    } catch (e) {
                                                                        // console.error('Caret positioning error:', e);
                                                                    }
                                                                    return;
                                                                }
                                                                charsLeft -= currentNode.length;
                                                                currentNode = walker.nextNode();
                                                            }

                                                            // Fallback: place cursor at end
                                                            try {
                                                                newRange.selectNodeContents(e.currentTarget);
                                                                newRange.collapse(false);
                                                                newSelection.removeAllRanges();
                                                                newSelection.addRange(newRange);
                                                            } catch (e) {
                                                                // console.error('Fallback caret positioning error:', e);
                                                            }
                                                        };

                                                        restoreSelection();

                                                        // 🔹 Check relation keyword match
                                                        if (selectedRelation) {
                                                            const relationMatches = relationKeys.some(key => {
                                                                const chipText = t.relations[key];
                                                                if (['hi', 'mr', 'ta'].includes(lanText)) {
                                                                    return inputText.includes(chipText);
                                                                }
                                                                const escapedChipText = chipText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                                                                const regex = new RegExp(`\\b${escapedChipText}\\b`, 'i');
                                                                return regex.test(inputText);
                                                            });

                                                            if (!relationMatches) {
                                                                setSelectedRelation(null);
                                                            }
                                                        }
                                                    }}
                                                    onKeyDown={handleKeyDown}
                                                    onFocus={(e) => {
                                                        if (isCheckingConnection || isProcessing) {
                                                            e.preventDefault();
                                                            e.target.blur();
                                                            return;
                                                        }
                                                        handleFocus(e);
                                                    }}
                                                    onBlur={handleBlur}
                                                    enterKeyHint="done"
                                                    className='form-control border-0 flex-grow-1 custom-textarea'
                                                    style={{
                                                        resize: 'none',
                                                        backgroundColor: 'transparent',
                                                        outline: 'none',
                                                        boxShadow: 'none',
                                                        color: 'black',
                                                        fontSize: '16px',
                                                        fontWeight: '400',
                                                        lineHeight: '1.5',
                                                        position: hintText || isTextareaFocused ? 'relative' : 'absolute',
                                                        top: hintText || isTextareaFocused ? 'auto' : '0',
                                                        whiteSpace: 'pre-wrap',
                                                        overflowWrap: 'break-word',
                                                        pointerEvents: (isCheckingConnection || isProcessing) ? 'none' : 'auto'
                                                    }}
                                                />
                                            </div>
                                            <div className='position-absolute'
                                                style={{
                                                    width: "100%",
                                                    bottom: 15,
                                                }}
                                            >
                                                <div>
                                                    <Swiper
                                                        spaceBetween={0}
                                                        slidesPerView="auto"
                                                        freeMode={true}
                                                        style={{ paddingRight: '55px' }}
                                                    >
                                                        {relationKeys.map((relationKey) => {
                                                            const chipText = t.relations[relationKey];
                                                            let isSelected;

                                                            if (['hi', 'mr', 'ta'].includes(lanText)) {
                                                                isSelected = hintText.includes(chipText);
                                                            } else {
                                                                const escapedChipText = chipText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                                                                const regex = new RegExp(`\\b${escapedChipText}\\b`, 'i');
                                                                isSelected = regex.test(hintText);
                                                            }

                                                            return (
                                                                <SwiperSlide key={relationKey} style={{ width: 'auto' }}>
                                                                    <p
                                                                        className='m-0 rounded-pill px-3 ms-2 GTMedium'
                                                                        style={{
                                                                            backgroundColor: isSelected
                                                                                ? 'black'
                                                                                : category === 'Q29uZmVzc2lvbg=='
                                                                                    ? '#EDCFFE'
                                                                                    : 'white',
                                                                            color: isSelected ? 'white' : 'rgba(0,0,0,0.6)',



                                                                            cursor: (isCheckingConnection || isProcessing) ? 'not-allowed' : 'pointer',
                                                                            fontSize: '14px',
                                                                            whiteSpace: 'nowrap',
                                                                            userSelect: 'none',
                                                                            transition: 'all 0s ease',
                                                                            padding: "2px 0px",
                                                                            pointerEvents: (isCheckingConnection || isProcessing) ? 'none' : 'auto'
                                                                        }}
                                                                        onClick={(e) => {
                                                                            if (isCheckingConnection || isProcessing) return;
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            handleChipSelect(relationKey);
                                                                        }}
                                                                    >
                                                                        # {chipText}
                                                                    </p>
                                                                </SwiperSlide>

                                                            );
                                                        })}
                                                    </Swiper>
                                                </div>
                                            </div>
                                        </div>

                                        <p className={`text-end pe-3 text-white my-1 GTMedium ${remainingChars <= 0 ? 'limit-reached' : ''}`}>
                                            {convertToNativeNumerals(typedChars, lanText)}/{convertToNativeNumerals(maxLength, lanText)}
                                        </p>

                                        <BadWordWarning
                                            visible={hasBadWord}
                                            message={
                                                t?.common?.badWordWarning ||
                                                "Avoid using offensive language"
                                            }
                                        />

                                        <div
                                            className="d-flex justify-content-center align-items-end px-3"
                                            style={{ height: '15%' }}
                                        >
                                            <Button
                                                className='bg-black rounded-pill w-custom-50 border-0 mb-2 mx-auto GTMedium'
                                                style={{
                                                    padding: isCheckingConnection ? "10px 1px" : "14px 1px",
                                                    height: "50px",
                                                    width: "min(350px, 80vw)",
                                                    maxWidth: "350px",
                                                    pointerEvents: (isCheckingConnection || isProcessing || !isNextButtonEnabled()) ? 'none' : 'auto',
                                                    cursor: (isCheckingConnection || isProcessing || !isNextButtonEnabled()) ? 'not-allowed' : 'pointer'
                                                }}
                                                onClick={handleSendClick}
                                                disabled={!isNextButtonEnabled() || isProcessing}
                                            >
                                                {isCheckingConnection ? (
                                                    <div className="custom-spinner" style={{ borderTopColor: "white" }} />
                                                ) : (
                                                    <span
                                                        style={{
                                                            fontSize: "clamp(21px, 4.5vw, 27px)",
                                                            lineHeight: 1,
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {t.common?.next}
                                                    </span>
                                                )}

                                            </Button>

                                        </div>

                                        <div className='w-100'
                                            style={{
                                                position: 'absolute',
                                                bottom: '7%',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                textAlign: 'center'
                                            }}
                                        >
                                            <img
                                                src={logo}
                                                alt="LOL"
                                                className="img-fluid"
                                                style={{ width: '110px' }}
                                            />

                                            <p className='GTRegular text-white' style={{ margin: '2px 0 0', fontSize: '13px' }}>
                                                {t.logoTitle || "Anonymous Roasting Game"}
                                            </p>
                                        </div>
                                    </motion.div>
                                )}

                                {active === 1 && (
                                    <motion.div
                                        key="upload"
                                        custom={direction}
                                        variants={slideVariants}
                                        initial="enter"
                                        animate="center"
                                        exit="exit"
                                        transition={{ duration: 0.2, ease: "easeInOut" }}
                                        className="d-flex flex-column justify-content-between"
                                        style={{ height: '100%' }}
                                    >
                                        {/* Section 1: Title - 15% */}
                                        <div
                                            className="d-flex justify-content-center align-items-center"
                                            style={{ height: '10%' }}
                                        >
                                            <p
                                                className="GTMedium m-0"
                                                style={{
                                                    color: isBlackText ? "#000" : "#fff",
                                                    fontSize: "clamp(20px, 2vh, 35px)",
                                                }}
                                            >
                                                {t.uploadtitle}
                                            </p>
                                        </div>

                                        {/* Section 2: Image Preview - 50% */}
                                        <div
                                            className="d-flex justify-content-center align-items-center mt-3 position-relative"
                                            style={{ height: '50%' }}
                                        >
                                            {selectedImage ? (
                                                <div
                                                    className="position-relative cursor"
                                                    style={{
                                                        opacity: isProcessing || isCheckingConnection2 ? 0.5 : 1,
                                                        width: !isSmallScreen ? 'min(280px, 70vw)' : '230px',
                                                        height: !isSmallScreen ? 'min(280px, 70vw)' : '230px',
                                                        maxWidth: !isSmallScreen ? '280px' : '230px',
                                                        maxHeight: !isSmallScreen ? '280px' : '230px'
                                                    }}
                                                >
                                                    <img
                                                        src={getBorderImage(category)}
                                                        className="img-fluid w-100 h-100"
                                                        alt="Avatar Border"
                                                    />

                                                    <div
                                                        onClick={() => {
                                                            if (isCheckingConnection3 || isProcessing || isCheckingConnection || isCheckingConnection2) return;
                                                            setImageModal(true);
                                                        }}

                                                        className="rounded-circle overflow-hidden bg-white d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "86%",
                                                            height: "86%",
                                                            position: "absolute",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform: "translate(-50%, -50%)",
                                                            backgroundImage: `url(${selectedImage})`,
                                                            backgroundSize: "cover",
                                                            backgroundPosition: "center",
                                                            backgroundRepeat: "no-repeat",
                                                        }}
                                                    >
                                                    </div>

                                                    {/* <div
                                                        onClick={() => setImageModal(true)}
                                                        className="rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "86%",
                                                            height: "86%",
                                                            position: "absolute",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform: "translate(-50%, -50%)",
                                                            backgroundColor: cardBg,
                                                        }}
                                                    >
                                                        <img
                                                            src={selectedImage}
                                                            alt="Selected"
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "fill"
                                                            }}
                                                        />
                                                    </div> */}

                                                    <div
                                                        className='position-absolute rounded-circle d-flex align-items-center justify-content-center'
                                                        style={{
                                                            width: "50px",
                                                            height: "50px",
                                                            bottom: "-10px",
                                                            left: "50%",
                                                            border: "2px solid black",
                                                            transform: "translateX(-50%)",
                                                            background: buttonBg,
                                                            pointerEvents: (isCheckingConnection3 || isProcessing || isCheckingConnection) ? 'none' : 'auto',
                                                            cursor: (isCheckingConnection3 || isProcessing || isCheckingConnection) ? 'not-allowed' : 'pointer'
                                                        }}
                                                        onClick={handleBoxClick2}
                                                    >
                                                        {isCheckingConnection3 ? (
                                                            <div className="custom-spinner" style={{ borderTopColor: color }} />
                                                        ) : (
                                                            <img src={retake} alt='retake' width={20} />
                                                        )}
                                                    </div>


                                                </div>
                                            ) : (
                                                <div
                                                    className="position-relative cursor"
                                                    onClick={handleBoxClick3}
                                                    style={{
                                                        cursor: (isProcessing || isCheckingConnection2 || isCheckingConnection) ? 'not-allowed' : 'pointer',
                                                        pointerEvents: (isProcessing || isCheckingConnection2 || isCheckingConnection) ? 'none' : 'auto',
                                                        width: !isSmallScreen ? 'min(280px, 70vw)' : '230px',
                                                        height: !isSmallScreen ? 'min(280px, 70vw)' : '230px',
                                                        maxWidth: !isSmallScreen ? '280px' : '230px',
                                                        maxHeight: !isSmallScreen ? '280px' : '230px'
                                                    }}
                                                >
                                                    <img
                                                        src={getBorderImage(category)}
                                                        className="img-fluid w-100 h-100"
                                                        alt="Avatar Placeholder"
                                                        style={{
                                                            opacity: isProcessing || isCheckingConnection2 ? 0.5 : 1,
                                                            transition: "opacity 0.3s ease"
                                                        }}
                                                    />

                                                    <div
                                                        className="rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "86%",
                                                            height: "86%",
                                                            position: "absolute",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform: "translate(-50%, -50%)",
                                                            backgroundImage: `url(${cachedImages.selfieImage})`,
                                                            backgroundSize: "cover",
                                                            backgroundPosition: "center",
                                                            backgroundRepeat: "no-repeat",
                                                        }}
                                                    >
                                                    </div>
                                                </div>
                                            )}

                                            {/* Loader overlay */}
                                            {(isProcessing || isCheckingConnection2) && (
                                                <div
                                                    className="position-absolute d-flex justify-content-center align-items-center rounded-full"
                                                    style={{
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        // backgroundColor: "rgba(255,255,255,0.6)",
                                                        zIndex: 10
                                                    }}
                                                >
                                                    <div
                                                        className="spinner-border spinner-border-sm"
                                                        style={{
                                                            width: "30px",
                                                            height: "30px",
                                                            color: color
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>


                                        {/* Section 3: Action Buttons - 35% */}
                                        <div
                                            className="d-flex flex-column justify-content-center align-items-center px-3 gap-2"
                                            style={{ height: '35%' }}
                                        >
                                            {selectedImage ? (
                                                <>
                                                    <Button
                                                        className='bg-black rounded-pill border-0 GTMedium d-flex align-items-center justify-content-center'
                                                        style={{
                                                            height: "50px", // 🔥 FIXED HEIGHT
                                                            width: 'min(350px, 80vw)',
                                                            maxWidth: '350px',
                                                            pointerEvents: (isCheckingConnection3 || isProcessing) ? 'none' : 'auto',
                                                            cursor: (isCheckingConnection3 || isProcessing) ? 'not-allowed' : 'pointer'
                                                        }}
                                                        onClick={handleSendClick}
                                                        disabled={!isNextButtonEnabled()}

                                                    >
                                                        {isCheckingConnection ? (
                                                            <div className="custom-spinner" style={{ borderTopColor: color }} />
                                                        ) : (
                                                            <span
                                                                style={{
                                                                    fontSize: "clamp(21px, 4.5vw, 27px)",
                                                                    lineHeight: "1",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {t.common.next}
                                                            </span>
                                                        )}
                                                    </Button>

                                                    <Button
                                                        className="text-black rounded-pill border-0 GTMedium d-flex align-items-center justify-content-center gap-2 mt-1"
                                                        style={{
                                                            padding: "14px 12px",
                                                            background: buttonBg,
                                                            height: "50px",
                                                            width: 'min(350px, 80vw)',
                                                            maxWidth: '350px',
                                                            pointerEvents: (isCheckingConnection3 || isProcessing || isCheckingConnection || isCheckingConnection2) ? 'none' : 'auto',
                                                            cursor: (isCheckingConnection3 || isProcessing || isCheckingConnection || isCheckingConnection2) ? 'not-allowed' : 'pointer'
                                                        }}
                                                        onClick={() => {
                                                            if (isCheckingConnection3 || isProcessing) return;
                                                            setSelectedImage(null);
                                                            sessionStorage.removeItem("sessionImage");
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                fontSize: "clamp(21px, 4.5vw, 27px)", // responsive font
                                                                lineHeight: 1,
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {t.common.clear}
                                                        </span>
                                                    </Button>

                                                </>
                                            ) : (
                                                <Button
                                                    className="bg-black rounded-pill border-0 GTMedium d-flex align-items-center justify-content-center gap-3"
                                                    style={{
                                                        padding: "14px 12px",
                                                        height: "50px",
                                                        width: "min(350px, 80vw)",
                                                        maxWidth: "350px",
                                                        lineHeight: 1,
                                                        pointerEvents: (isCheckingConnection || isProcessing || isCheckingConnection2) ? 'none' : 'auto',
                                                        cursor: (isCheckingConnection || isProcessing || isCheckingConnection2) ? 'not-allowed' : 'pointer'
                                                    }}
                                                    onClick={handleBoxClick}
                                                >

                                                    {isCheckingConnection ? (
                                                        <div className="custom-spinner" style={{ borderTopColor: color }} />
                                                    ) : (
                                                        <>
                                                            <img
                                                                src={cachedImages.cameraIcon}
                                                                alt="camera"
                                                                style={{
                                                                    width: "clamp(22px, 5vw, 30px)",
                                                                    height: "clamp(22px, 5vw, 30px)",
                                                                    display: "block",
                                                                }}
                                                            />
                                                            <span
                                                                className="m-0 d-flex align-items-center"
                                                                style={{
                                                                    fontSize: "clamp(21px, 4.5vw, 27px)", // 🔥 responsive BIG font
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {t.addselfie}
                                                            </span>

                                                        </>
                                                    )}
                                                </Button>

                                            )}
                                        </div>
                                    </motion.div>
                                )}


                            </AnimatePresence>
                        </div>
                    </div>
                </div>

                <RotatePhonePopup
                    excludeWhen={[]}
                />

                {/* Only show UploadModal on non-iOS devices */}
                {!isIOS && (
                    <UploadModal
                        show={showModal}
                        onClose={() => setShowModal(false)}
                        onImageSelect={handleImageSelect}
                        onProcessing={(processing) => {
                            setIsProcessing(processing);
                        }}
                        onError={(errorMessage) => {
                            showSnackbar(errorMessage, "error");
                        }}
                        camera={cachedImages.camera}
                        gallery={cachedImages.gallery}
                        t={t}
                        detect={true}
                    />
                )}

                <AnimatePresence mode="wait">
                    {imageModal && (
                        <motion.div
                            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                            style={{
                                zIndex: 99999,
                                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                backdropFilter: 'blur(5px)',
                            }}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.3 }}
                            onClick={() => setImageModal(false)}
                        >
                            <motion.div
                                className="rounded-4 p-3 text-center"
                                style={{
                                    maxWidth: '350px',
                                    width: '85%',
                                    position: 'relative',
                                }}
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                exit={{ scale: 0, opacity: 0 }}
                                transition={{
                                    duration: 0.4,
                                    ease: [0.34, 1.56, 0.64, 1]
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setImageModal(false);
                                }}

                            >
                                <div
                                    className="d-flex justify-content-center align-items-center position-relative"
                                    onClick={() => setImageModal(false)}
                                    style={{
                                        width: '100%',
                                        aspectRatio: '1/1',
                                        maxWidth: '280px',
                                        margin: '0 auto'
                                    }}
                                >
                                    <div
                                        className="position-relative"
                                        style={{
                                            width: '100%',
                                            height: '100%'
                                        }}
                                    >
                                        <div
                                            className="rounded-circle border border-3 border-white overflow-hidden bg-white d-flex align-items-center justify-content-center"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                backgroundImage: `url(${selectedImage})`,
                                                backgroundSize: "cover",
                                                backgroundPosition: "center",
                                                backgroundRepeat: "no-repeat",
                                                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                            }}
                                        >
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>


            </div >
        </>
    );
};

export default AllHintPage;
